import styled from 'styled-components'
import { breakpoints } from '../../constants'
import {
	BLUE,
	MEDIUMORANGE,
	PRIMARY_LIGHT,
	WHITE,
} from '../../styles/colors.style'

export const Container = styled.section`
	margin-top: 5px;
	display: flex;
	flex-direction: column;

	.fa-close {
		top: 3px;
		right: 5px;
		font-size: 4rem;
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
	}

	.lk-resume {
		border: 0;
		border-radius: 5px;
		width: 260px;
		height: 50px;
		display: block;
		margin: 0 auto;
		color: ${WHITE};
		background: ${MEDIUMORANGE};
		font: 600 16px/50px 'Source Sans Pro';
		text-align: center;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
		&.upper {
			text-transform: uppercase;
		}
	}
`

export const MyCard = styled.section`
	margin: 20px auto;
	width: 336px;

	@media (min-width: ${breakpoints.NOTEBOOK}px) {
		width: 100%;
		max-width: 1200px;
		margin: 0 auto;
	}
`

export const MonthCard = styled.h2`
	border-bottom: 1px solid ${PRIMARY_LIGHT};
	color: ${PRIMARY_LIGHT};
	font: 600 25px/32px 'Source Sans Pro';
	text-align: center;
	text-transform: uppercase;
	margin-bottom: 20px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		display: none;
	}
`

export const BoxCard = styled.section`
	margin: 0 auto;
	border: 2px solid ${BLUE};
	border-radius: 5px;

	@media (min-width: ${breakpoints.NOTEBOOK}px) {
		display: flex;
		justify-content: space-between;
		width: 100%;
		border: 0;
	}
`

export const SummaryBox = styled.div`
	background: ${WHITE};
	padding: 40px 20px;

	.footer-modal {
		display: flex;
		align-items: flex-end;
		min-height: 20vh;
	}
`
